/* eslint-disable */
import uiI18n from "../../i18n";
import {
  doc,
  getDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  setDoc,
  arrayUnion,
  increment,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";

// Action Types
const FETCH_CALLNAME = "FETCH_CALLNAME";
const UPDATE_CALLNAME = "UPDATE_CALLNAME";
const FETCH_ALL_ACCOUNTS = "FETCH_ALL_ACCOUNTS";
const FETCH_PAID_ACCOUNTS = "FETCH_PAID_ACCOUNTS";
const FETCH_UNPAID_ACCOUNTS = "FETCH_UNPAID_ACCOUNTS";
const SET_ACTIVE_FILTER = "SET_ACTIVE_FILTER";
const SET_COPIED = "SET_COPIED";
const SET_ERROR = "SET_ERROR";
const CLEAR_ERROR = "CLEAR_ERROR";
const SET_LOADING = "SET_LOADING";
const SET_LOADING_ACCOUNTS = "SET_LOADING_ACCOUNTS";

// Initial State
const initialState = {
  callName: null,
  referralLink: "",
  signUpLink: "",
  loading: false,
  loadingAccounts: false,
  error: null,
  allAccounts: [],
  paidAccounts: [],
  unpaidAccounts: [],
  activeFilter: "All",
  copied: {
    callName: false,
    signUpLink: false,
  },
};

// Synchronous Action Creators
export const setCallName = (callName) => ({
  type: FETCH_CALLNAME,
  payload: callName,
});


export const setAllAccounts = (accounts) => ({
  type: FETCH_ALL_ACCOUNTS,
  payload: accounts,
});

export const setPaidAccounts = (accounts) => ({
  type: FETCH_PAID_ACCOUNTS,
  payload: accounts,
});

export const setUnpaidAccounts = (accounts) => ({
  type: FETCH_UNPAID_ACCOUNTS,
  payload: accounts,
});

export const setActiveFilter = (filter) => ({
  type: SET_ACTIVE_FILTER,
  payload: filter,
});

export const setCopied = (field, value) => ({
  type: SET_COPIED,
  payload: { field, value },
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setLoadingAccounts = (isLoading) => ({
  type: SET_LOADING_ACCOUNTS,
  payload: isLoading,
});

// Helper functions

/**
 * Verify if a callName exists in the database
 * @param {string} callName - The callName to verify
 * @returns {Promise<boolean>} - True if the callName exists, false otherwise
 */
export const verifyCallNameExists = async (callName) => {
  try {
    if (!callName) return false;

    const accountsRef = collection(db, "account");
    const q = query(accountsRef, where("callName", "==", callName));
    const querySnapshot = await getDocs(q);

    return !querySnapshot.empty; // Returns true if callName exists
  } catch (error) {
    console.error("Error verifying callName:", error);
    return false;
  }
};

/**
 * Generate referral link with callName
 * @param {string} callName - The callName to use for the referral link
 * @returns {string} - The referral link
 */


/**
 * Generate verified referral link after verifying callName exists
 * @param {string} callName - The callName to use for the referral link
 * @returns {Promise<string|null>} - The referral link if callName exists, null otherwise
 */


/**
 * Get referral callName from URL
 * @returns {string|null} - The referral callName or null if not found
 */
export const getReferralFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("ref");
};

/**
 * Share affiliate link via different platforms
 * @param {string} platform - The platform to share on
 * @param {string} shareLink - The link to share
 * @param {string} [message] - Optional custom message for sharing
 * @returns {boolean} - True if successful, false otherwise
 */
export const shareAffiliateLink = (platform, shareLink, message) => {
  try {
    const shareMessage =
      message ||
      `Sign up using my referral link and get a discount! ${shareLink}`;

    switch (platform) {
      case "facebook":
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            shareLink
          )}`,
          "_blank"
        );
        break;
      case "twitter":
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            shareMessage
          )}`,
          "_blank"
        );
        break;
      case "whatsapp":
        window.open(
          `https://api.whatsapp.com/send?text=${encodeURIComponent(
            shareMessage
          )}`,
          "_blank"
        );
        break;
      case "email":
        window.open(
          `mailto:?subject=Join%20with%20my%20referral%20link&body=${encodeURIComponent(
            shareMessage
          )}`,
          "_blank"
        );
        break;
      case "messenger":
        window.open(
          `https://www.facebook.com/dialog/send?link=${encodeURIComponent(
            shareLink
          )}&app_id=YOUR_FACEBOOK_APP_ID&redirect_uri=${encodeURIComponent(
            window.location.origin
          )}`,
          "_blank"
        );
        break;
      case "tiktok":
        // TikTok doesn't have a direct sharing API, so copy to clipboard instead
        try {
          navigator.clipboard.writeText(shareLink);
        } catch (err) {
          // Fallback for browsers that don't support clipboard API
          const tempInput = document.createElement("input");
          document.body.appendChild(tempInput);
          tempInput.value = shareLink;
          tempInput.select();
          document.execCommand("copy");
          document.body.removeChild(tempInput);
        }

        // Show a success message
        Swal.fire({
          icon: "success",
          title: uiI18n.t("ui.linkCopied"),
          text: uiI18n.t("navbar.try.linkCopiedText"),
          confirmButtonText: uiI18n.t("ship.ok"),
          confirmButtonColor: "#7e5395",
          timer: 3000,
          timerProgressBar: true,
          position: "bottom-end",
          toast: true,
          showConfirmButton: false,
        });
        break;
      default:
        // Copy to clipboard
        try {
          navigator.clipboard.writeText(shareLink);
        } catch (err) {
          // Fallback for browsers that don't support clipboard API
          const tempInput = document.createElement("input");
          document.body.appendChild(tempInput);
          tempInput.value = shareLink;
          tempInput.select();
          document.execCommand("copy");
          document.body.removeChild(tempInput);
        }

        Swal.fire({
          icon: "success",
          title: uiI18n.t("ui.linkCopied"),
          text: uiI18n.t("navbar.try.linkCopiedText"),
          confirmButtonText: uiI18n.t("ship.ok"),
          confirmButtonColor: "#7e5395",
          timer: 3000,
          timerProgressBar: true,
          position: "bottom-end",
          toast: true,
          showConfirmButton: false,
        });
    }

    return true;
  } catch (error) {
    console.error("Error sharing affiliate link:", error);
    return false;
  }
};




/**
 * Register a new user with referral information
 * @param {Object} userData - User data including uid, email, callName
 * @param {string} invitedBy - The callName that referred this user
 * @returns {Promise<Object>} - Object with success flag and optional error
 */


// Reducer
const affiliate = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CALLNAME:
      const callName = action.payload;
      let referralLink = "";
      let signUpLink = "";

      if (callName) {
        const baseUrl = window.location.origin;
        referralLink = generateReferralLink(callName);
        signUpLink = `${baseUrl}/sign-up?ref=${encodeURIComponent(callName)}`;
      }

      return {
        ...state,
        callName,
        referralLink,
        signUpLink,
      };

    case UPDATE_CALLNAME:
      const updatedCallName = action.payload;
      let updatedReferralLink = "";
      let updatedSignUpLink = "";

      if (updatedCallName) {
        const baseUrl = window.location.origin;
        updatedReferralLink = generateReferralLink(updatedCallName);
        updatedSignUpLink = `${baseUrl}/sign-up?ref=${encodeURIComponent(
          updatedCallName
        )}`;
      }

      return {
        ...state,
        callName: updatedCallName,
        referralLink: updatedReferralLink,
        signUpLink: updatedSignUpLink,
      };

    case FETCH_ALL_ACCOUNTS:
      return {
        ...state,
        allAccounts: action.payload,
      };

    case FETCH_PAID_ACCOUNTS:
      return {
        ...state,
        paidAccounts: action.payload,
      };

    case FETCH_UNPAID_ACCOUNTS:
      return {
        ...state,
        unpaidAccounts: action.payload,
      };

    case SET_ACTIVE_FILTER:
      return {
        ...state,
        activeFilter: action.payload,
      };

    case SET_COPIED:
      return {
        ...state,
        copied: {
          ...state.copied,
          [action.payload.field]: action.payload.value,
        },
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_LOADING_ACCOUNTS:
      return {
        ...state,
        loadingAccounts: action.payload,
      };

    default:
      return state;
  }
};

export default affiliate;
